'use strict';

var AlgoliaSearch = require('../../AlgoliaSearch.js');
var createAlgoliasearch = require('../createAlgoliasearch.js');

module.exports = createAlgoliasearch(AlgoliaSearch);



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/browser/builds/algoliasearch.js
// module id = 590
// module chunks = 0